import { render, staticRenderFns } from "./messagePushConfigurationList.vue?vue&type=template&id=4e2d35d7&scoped=true"
import script from "./messagePushConfigurationList.vue?vue&type=script&lang=js"
export * from "./messagePushConfigurationList.vue?vue&type=script&lang=js"
import style0 from "./messagePushConfigurationList.vue?vue&type=style&index=0&id=4e2d35d7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2d35d7",
  null
  
)

export default component.exports